<template>
  <v-navigation-drawer
    v-model="drawer"
    absolute
    temporary
    right
    style="top: 64px"
    width="400"
  >
    <v-list-item class="mt-4">
      <v-list-item-content>
        <v-list-item-title class="title">Settings</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-alert
      v-if="dirty"
      class="mx-4"
      border="top"
      color="primary"
      type="info"
      elevation="2"
    >
      After saving the preferred sensor units, application will be reloaded.
      Please save your content.
    </v-alert>

    <v-list>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>Sensor configuration:</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-select
            class="mt-0 pt-0"
            :items="unitOptions"
            v-model="unit"
            label="Units"
            @change="dirty = true"
          ></v-select>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <!-- <v-list>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>Preferred language:</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-select
            class="mt-0 pt-0"
            :items="languageOptions"
            v-model="language"
            label="Languages"
            @change="dirty = true"
          ></v-select>
        </v-list-item-content>
      </v-list-item>
    </v-list> -->

    <v-card-actions class="mt-4">
      <v-btn text @click="drawer = false">Close</v-btn>
      <v-spacer></v-spacer>
      <v-btn v-if="dirty" @click="handleSave" :loading="loading" color="primary"
        >Save</v-btn
      >
    </v-card-actions>
  </v-navigation-drawer>
</template>
<script>
import api from "@/utils/api";
import { USER_CRM_REQUEST } from "@/store/actions/user";
import { mapGetters } from "vuex";
export default {
  props: {
    active: {
      type: Boolean,
      default: Boolean,
    },
  },

  data() {
    return {
      unitOptions: [
        { text: "Metric", value: "METRIC" },
        { text: "Imperial", value: "IMPERIAL" },
      ],
      languageOptions: [
        { text: "Metric", value: "METRIC" },
        { text: "Imperial", value: "IMPERIAL" },
      ],
      unit: null,
      dirty: false,
      loading: false,
      saved: false,
    };
  },
  created() {
    this.unit = this.getMe.user.profile.unit_preference;
  },
  computed: {
    ...mapGetters(["getMe"]),
    drawer: {
      get: function () {
        return this.active;
      },
      set: function (value) {
        this.$emit("close-settings", value, this.saved);
      },
    },
  },
  methods: {
    handleSave() {
      this.loading = true;
      api
        .updateProfile({
          name: "",
          website: "",
          unit_preference: this.unit,
        })
        .then((resp) => {
          this.$store.dispatch(USER_CRM_REQUEST).then((resp) => {
            this.saved = true;
            this.drawer = false;
            this.loading = false;
          });
        })
        .catch((err) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
.navigation-a-underline--remove {
  text-decoration: none;
}
</style>
